import { render } from "./ViewPlayer.vue?vue&type=template&id=284fc2b0"
import script from "./ViewPlayer.vue?vue&type=script&lang=js"
export * from "./ViewPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__